import React from 'react';
import { Select, SelectProps } from 'antd';

export interface AccessibleSelectProps extends SelectProps {
  /** WCAG 1.3.5 token for the search input: rc-select forwards it, antd's types omit it. */
  autoComplete?: string;
}

export const AccessibleSelect = React.forwardRef<
  React.ComponentRef<typeof Select>,
  AccessibleSelectProps
>((props, ref) => {
  return (
    <Select
      ref={ref}
      // Default `showSearch` filtering to the visible label so typing matches
      // by name (e.g. "ukr" -> "Ukraine"); antd defaults optionFilterProp to
      // "value", which would only match option codes. Placed before {...props}
      // so callers can still override it. (Previously a hard-coded
      // filterOption={false} here disabled client-side filtering entirely.)
      optionFilterProp="label"
      {...props}
      virtual={false}
      getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
    />
  );
});

AccessibleSelect.displayName = 'AccessibleSelect';
